/* eslint-disable react/jsx-filename-extension */

import React from 'react';
import ReactDOM from 'react-dom';

import NewsletterForm from './NewsletterForm';

const newsletterFormContainers = document.querySelectorAll('[data-newsletter-form]');
[...newsletterFormContainers].forEach((newsletterFormContainer) => {
    const data = {...newsletterFormContainer.dataset};
    data.placeholders = JSON.parse(data.placeholders);
    data.subsite = JSON.parse(data.subsite);

    ReactDOM.render(
        <NewsletterForm {...data} />,
        newsletterFormContainer,
    );
});
